import { render, staticRenderFns } from "./StatusText.vue?vue&type=template&id=4c7e7470&"
import script from "./StatusText.vue?vue&type=script&lang=js&"
export * from "./StatusText.vue?vue&type=script&lang=js&"
import style0 from "./StatusText.vue?vue&type=style&index=0&id=4c7e7470&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports